import { Operatore } from "./Operatore";
import { Struttura } from "./Struttura";

export class CotDisponibilita {
    id: string | undefined;
    data: Date | null = null;
    oraInizio: Date | null = null;
    oraFine: Date | null = null;
    durata: number | null = null;
    struttura: Struttura | null = null;
    operatori: Operatore[] | null = null;
    cotRichiestaOid: number | null = null;
    codice: string | null = null;
}